<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Soutenir',

    metaInfo: { title: 'Soutenir le FIP' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'soutenir',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'soutenir',
      },
    },
  }
</script>
